import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../redux/action/index';
import { Validator } from '@/utils/formValidator';
import axios from 'axios';
import { api_config } from '../../../../constants/api';
import { useTranslation } from 'react-i18next';
import { checkGoogleSafe } from '../../../../api/apis';
import Cookies from 'js-cookie';
import Device from 'current-device';
export default function Security(props) {
  let timer;
  let second = 0;
  const dispatch = useDispatch();
  const { t } = useTranslation('userLoginTips');
  const reducerData = useSelector((state) => state.common);
  const workData = useSelector((state) => state.work);
  const { userEmail } = reducerData;
  const [codeLoading, setCodeLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [time, setTime] = useState(0);
  const [form] = Form.useForm();
  const getCode = () => {
    let email = userEmail.email;
    let formData = new FormData();
    formData.append('email', email);
    formData.append('is_validate', 1);
    setCodeLoading(true);
    axios({
      method: 'POST',
      url: api_config.API_V2_URL + 'accounts/verification-code',
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          setCodeLoading(false);
          message.success('It has been set to your mailbox, please check it.');
          localStorage.setItem('secTime', new Date().getTime().toString());
          waitTime();
          localStorage.setItem('emailToken', res.data.token); //保存用户的验证码token
          dispatch(action.sendVerification(res.data));
        }
      })
      .catch((err) => {
        setCodeLoading(false);
        let res = err.response;
        if (res.status === 500) {
          message.error(t('500'));
        } else {
          switch (res.data.code) {
            case 404001:
              message.error(t('NoaccountfoundwiththatEmailaddress'));
              break;
            case 400104:
              message.error(t('ThisEmailhasbeenregisteredpleasechooseanother'));
              break;
            default:
              message.error(t('500'));
          }
        }
      });
  };

  const waitTime = () => {
    let sendTime = localStorage.getItem('secTime');
    if (sendTime == null) {
      clearInterval(timer);
    } else {
      timer = setInterval(() => {
        if (second < 0) {
          localStorage.removeItem('secTime');
          clearTimeout(timer);
          second = 0;
          setTime(second);
        } else {
          second = (
            60 -
            (new Date().getTime() - parseInt(sendTime)) / 1000
          ).toFixed(0);
          setTime(second);
        }
      }, 1000);
    }
  };
  const onFinish = (value) => {
    console.log(value);
    setLoading(true);
    checkGoogleSafe({
      email: value.email,
      code: value.verification,
      token: localStorage.getItem('emailToken'),
      id: localStorage.getItem('googleId'),
    })
      .then((obj) => {
        console.log(obj);
        if (obj.code === 200) {
          let hostname = window.location.hostname;
          Cookies.set('authorization', obj.data.authorization, {
            expires: 30,
          });
          Cookies.set('access_token', obj.data.account_access_token, {
            expires: 30,
            domain: hostname.substring(hostname.indexOf('.'), hostname.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: window.location.hostname.substring(
              window.location.hostname.indexOf('.'),
              window.location.hostname.length
            ),
          });
          props.changeStep(1);
          dispatch(
            action.onSignUpModal({
              visible: false,
            })
          );
          dispatch(action.onAuthorizationChange(obj.data.authorization));
          if (workData.work === 'dynamicPhoto') {
            let obj = {
              visible: true,
              //text: localStorage.getItem('purchaseGa'),
            };

            dispatch(action.onExceed2M(obj));
          }
          //  localStorage.removeItem('purchaseGa');
        }
        if (obj.code === 400301) {
          message.error(t('Invalidverificationcodepleasereenterthecorrectone'));
        }
        if (obj.code === 400223) {
          message.error(t('reg400223'));
        }
        if (obj.code === 400224) {
          message.error(t('reg400224'));
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        // let res = err.response;
        // switch (res.data.code) {
        //   case 400224:
        //     message.error(t("reg400224"));
        //     break;
        //   case 400223:
        //     message.error(t("reg400223"));
        //     break;
        //   case 400301:
        //     message.error(
        //       t("Invalidverificationcodepleasereenterthecorrectone")
        //     );
        //     break;
        //   default:
        //     message.error(t("500"));
        // }
      });
  };

  useEffect(() => {
    if (userEmail.email) {
      form.setFieldsValue({
        email: userEmail.email,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail]);

  useEffect(() => {
    waitTime();
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderBtn = () => {
    return time === 0 && !codeLoading ? (
      <span onClick={() => getCode()}>{t('GetCode')}</span>
    ) : codeLoading ? (
      <div style={{ display: 'inline-block' }}>
        <svg
          t='1652349039889'
          className='loadIcon'
          viewBox='0 0 1024 1024'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          p-id='4581'
        >
          <path
            d='M512 907c-24.852 0-45-20.148-45-45s20.148-45 45-45c168.446 0 305-136.554 305-305S680.446 207 512 207 207 343.554 207 512c0 24.852-20.148 45-45 45S117 536.852 117 512c0-218.152 176.848-395 395-395S907 293.848 907 512 730.152 907 512 907z'
            fill='#9F9FA1'
          ></path>
        </svg>
      </div>
    ) : (
      <span style={{ cursor: 'not-allowed', color: '#8372FF' }}>{time}s</span>
    );
  };
  return (
    <div className='security'>
      <div>
        <div className='loginTitle'>{t('Securityverification')}</div>
        <div className='loginSubTitle'>
          {t('youraccount')} {userEmail.email}{' '}
          {t('alreadyexiststoensurethesecuritypleaseverifyitfirst')}
        </div>
        <div>
          <Form form={form} onFinish={onFinish}>
            <Form.Item
              className='formItem'
              name='email'
              initialValue={userEmail.email}
            >
              <Input placeholder={t('Email')} className='inputForm' readOnly />
            </Form.Item>
            <Form.Item
              className='formItem'
              name='verification'
              validateTrigger='onBlur'
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  validator: Validator.emptyValidator,
                },
              ]}
            >
              <Input
                addonAfter={renderBtn()}
                className='verificationInput'
                placeholder={t('Verificationcode')}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={loading}
                className='loginBtn'
                type='primary'
                htmlType='submit'
              >
                {t('Confirm')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
